import * as queryString from 'query-string';
import { getResponse } from './getResponse.js';

const MF_TEST_VERSION_SEPARATOR = '~';
// eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
function NOOP() { }
function stripTrailingSlash(str) {
    return str.endsWith('/') ? str.slice(0, -1) : str;
}
async function getAllMfData({ testOverridesQueryParams, isAssetsFlattened, mfUrl, mfsToPreload, }) {
    const params = queryString.stringify({
        'test_overrides[]': testOverridesQueryParams,
        flatten: isAssetsFlattened || undefined,
        preloaded_mfs: mfsToPreload,
    });
    const queryParamString = params ? `?${params}` : '';
    return getResponse(`${mfUrl}/allMfData${queryParamString}`);
}

export { MF_TEST_VERSION_SEPARATOR, NOOP, getAllMfData, stripTrailingSlash };
